import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { TextField, Grid } from '@material-ui/core'

class EditRiskRuleBigRichCompDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskRuleBigRichCompDialog', options)
        }
    }

    state = {
        big_r_input: {},
        big_r_cancel_input: {},
        dialogOpen: false,
        isLoading: false,
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(pfSubPfId, riskRuleList) {
        const bigRichCompRiskRule = riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, pfSubPfId)]
        const bigRichCompCancelRiskRule = riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL, pfSubPfId)]

        this.setState({
            big_r_input: {
                accumulated_days: bigRichCompRiskRule.accumulated_days,
                round_above: bigRichCompRiskRule.round_boundary[0],
                rtp_below: bigRichCompRiskRule.rtp_boundary[1],
                loss_prize_above: bigRichCompRiskRule.prize_boundary ? -bigRichCompRiskRule.prize_boundary[1] : 0,
            },
            big_r_cancel_input: {
                accumulated_days: bigRichCompCancelRiskRule.accumulated_days,
                rtp_above: bigRichCompCancelRiskRule.rtp_boundary[0],
            },
            riskRuleList: riskRuleList,
            pfSubPfId: pfSubPfId,
            isLoading: false,
        })
    }

    OpenDialog(pfSubPfId, riskRuleList) {
        this.reset(pfSubPfId, riskRuleList)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        const promiseList = []

        const bigRichCompRiskRule = this.state.riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, this.state.pfSubPfId)]
        const updateHoneymoon1RulePromise = new Promise((resolve, reject) => {
            utils.apiRequest(
                'patch',
                API.RISKMGT_RISK_RULE,
                {
                    id: bigRichCompRiskRule.id,
                    accumulated_days: parseInt(this.state.big_r_input.accumulated_days),
                    round_boundary: [parseInt(this.state.big_r_input.round_above), RISKMGT.MAX_FLOAT],
                    rtp_boundary: [-RISKMGT.MAX_FLOAT, parseInt(this.state.big_r_input.rtp_below)],
                    prize_boundary: [-RISKMGT.MAX_FLOAT, -parseInt(this.state.big_r_input.loss_prize_above)],
                },
                (_data) => {
                    resolve()
                },
                () => {
                    reject()
                },
                true
            )
        })
        promiseList.push(updateHoneymoon1RulePromise)

        const bigRichCompCancelRiskRule =
            this.state.riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL, this.state.pfSubPfId)]
        const updateHoneymoon2RulePromise = new Promise((resolve, reject) => {
            utils.apiRequest(
                'patch',
                API.RISKMGT_RISK_RULE,
                {
                    id: bigRichCompCancelRiskRule.id,
                    accumulated_days: parseInt(this.state.big_r_cancel_input.accumulated_days),
                    rtp_boundary: [parseInt(this.state.big_r_cancel_input.rtp_above), RISKMGT.MAX_FLOAT],
                },
                (_data) => {
                    resolve()
                },
                () => {
                    reject()
                },
                true
            )
        })
        promiseList.push(updateHoneymoon2RulePromise)

        Promise.all(promiseList)
            .then(() => {
                utils.addToast(this.t('success'), 'success')
                this.props.confirmCallback()
                this.closeDialog()
            })
            .catch(() => {
                // this.setState({ confirmDisabled: false });
            })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {this.t('enableBigRichCompensation')}
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('accumulatedDays')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_input.accumulated_days}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 1 || isNaN(value)) {
                                        value = 1
                                    }

                                    this.setState({
                                        big_r_input: {
                                            ...this.state.big_r_input,
                                            accumulated_days: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('roundAbove')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_input.round_above}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        big_r_input: {
                                            ...this.state.big_r_input,
                                            round_above: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('rtpBelow')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_input.rtp_below}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        big_r_input: {
                                            ...this.state.big_r_input,
                                            rtp_below: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('lossPrizeAbove')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_input.loss_prize_above}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        big_r_input: {
                                            ...this.state.big_r_input,
                                            loss_prize_above: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12}>
                            {this.t('disableBigRichCompensation')}
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('accumulatedDays')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_cancel_input.accumulated_days}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 1 || isNaN(value)) {
                                        value = 1
                                    }

                                    this.setState({
                                        big_r_cancel_input: {
                                            ...this.state.big_r_cancel_input,
                                            accumulated_days: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('rtpAbove')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.big_r_cancel_input.rtp_above}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        big_r_cancel_input: {
                                            ...this.state.big_r_cancel_input,
                                            rtp_above: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.confirm()
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditRiskRuleBigRichCompDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditRiskRuleBigRichCompDialog)
